export enum SortBy {
	PRICE = 'price',
	NAME = 'name',
}

export enum DistributionType {
	HOSPITAL = 'hospital',
	RETAIL = 'retail',
}

export type SpecialStatus = {
	code: string;
	name: string;
};
